import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mr-4 user-info" }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import WageCalc from '../common/WageCalc.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmLayout',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 로고 이미지
const logoImage = ref(new URL('../../assets/images/hypehive-logo.png', import.meta.url).href);

// 사이드바 상태
const drawer = ref(false);

// 사용자 정보 (Vuex에서 가져오기)
const userInfo = computed(() => store.getters.currentUser);

// 관리자 권한으로 실행 중인지 확인 (센터접속)
const isImpersonating = computed(() => store.getters.isImpersonating);

// 메뉴 아이템들
const menuItems = computed(() => [
  {
    title: '사원관리',
    icon: 'mdi-account-multiple-check',
    to: '/pgm/employees'
  },
  {
    title: '수급자 일정',
    icon: 'mdi-account-heart',
    to: '/pgm/fna/beneficiary'
  },
  {
    title: '임금관리',
    icon: 'mdi-clipboard-check-outline',
    to: '/pgm/wage/WageProcess'
  },
  {
    title: '기관운영현황',
    icon: 'mdi-chart-line',
    to: '/pgm/dashboard'
  },
  {
    title: '재무회계',
    icon: 'mdi-cash-multiple',
    children: [
      {
        title: '예산작성',
        icon: 'mdi-calculator',
        to: '/pgm/fna/budget'
      },
      {
        title: '현금출납부',
        icon: 'mdi-book-open-page-variant',
        to: '/pgm/fna/inout'
      }
    ]
  },
  {
    title: '설정',
    icon: 'mdi-cog',
    children: [
      {
        title: '공지사항',
        icon: 'mdi-bullhorn',
        to: '/pgm/notice'
      }
    ]
  }
]);

// 사용자 정보 페이지로 이동
const goToUserInfo = () => {
  router.push('/pgm/userinfo');
};

// 로그아웃 처리
const handleLogout = async () => {
  try {
    await store.dispatch('performLogout');
    router.push('/pgm/login');
  } catch (error) {
    console.error('로그아웃 오류:', error);
  }
};

// 컴포넌트 마운트 시 로그인 상태 확인
onMounted(async () => {
  await store.dispatch('validateAuth');
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "inspire",
    class: "pgm-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "white",
        elevation: "1",
        height: "50",
        class: "pgm-app-bar"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value))
          }),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createTextVNode(" CAION ", -1)),
              (isImpersonating.value)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: "warning",
                    variant: "flat",
                    size: "small",
                    class: "ml-3 impersonate-badge"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-shield-account", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[3] || (_cache[3] = _createTextVNode(" 관리자 권한으로 실행 중 ", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_1, _toDisplayString(userInfo.value?.m_sisul_name || ''), 1),
          _createVNode(_component_v_menu, { class: "user-menu" }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, { class: "mr-2" }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-account-circle", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { onClick: goToUserInfo }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("mdi-information-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[7] || (_cache[7] = _createTextVNode(" 계정 정보 ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, { onClick: handleLogout }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("mdi-logout", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[9] || (_cache[9] = _createTextVNode(" 로그아웃 ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
        temporary: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.title
                }, [
                  (!item.children)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        to: item.to,
                        "prepend-icon": item.icon,
                        title: item.title,
                        class: "menu-item"
                      }, null, 8, ["to", "prepend-icon", "title"]))
                    : (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 1,
                        value: item.title,
                        "prepend-icon": item.icon
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                            title: item.title,
                            class: "menu-item"
                          }), null, 16, ["title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: child.title,
                              to: child.to,
                              "prepend-icon": child.icon,
                              title: child.title,
                              class: "menu-item submenu-item"
                            }, null, 8, ["to", "prepend-icon", "title"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "prepend-icon"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(WageCalc)
    ]),
    _: 3
  }))
}
}

})